import { Location } from 'history';
import { createAsyncAction } from 'typesafe-actions';

import { Meta } from './sagaApi';

export interface InitAppPayload {
  location?: Location;
  meta?: Meta<any>;
}

const initApp = createAsyncAction('@lib/initApp/REQUEST', '@lib/initApp/SUCCESS', '@lib/initApp/FAILURE')<
  InitAppPayload,
  any,
  any
>();

export default initApp;
